import { render, staticRenderFns } from "./ProofreadingPendingWorkDialog.vue?vue&type=template&id=5ea20e19&scoped=true"
import script from "./ProofreadingPendingWorkDialog.vue?vue&type=script&lang=ts"
export * from "./ProofreadingPendingWorkDialog.vue?vue&type=script&lang=ts"
import style0 from "./ProofreadingPendingWorkDialog.vue?vue&type=style&index=0&id=5ea20e19&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea20e19",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ea20e19')) {
      api.createRecord('5ea20e19', component.options)
    } else {
      api.reload('5ea20e19', component.options)
    }
    module.hot.accept("./ProofreadingPendingWorkDialog.vue?vue&type=template&id=5ea20e19&scoped=true", function () {
      api.rerender('5ea20e19', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ui/dialogs/ProofreadingPendingWorkDialog.vue"
export default component.exports